import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export const ProtectedRoute = ({ children, role }) => {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-yc-cream">
                <div className="font-heading text-lg" data-testid="protected-loading">Loading…</div>
            </div>
        );
    }
    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }
    if (user.role === "unset") {
        return <Navigate to="/role" replace />;
    }
    if (role && user.role !== role && user.role !== "admin") {
        return <Navigate to={`/${user.role}/dashboard`} replace />;
    }
    return children;
};
